<!--
- 投融资总趋势 平均融资额
- 作者：王尧
- 修改时间：2019-12-10
- 图表点击交互模式修改，代码优化
 -->
<template>
<div class="financing_data">
  <div class="chart_bg">
    <div class="title">
      <span class="chart_name">平均融资额（亿{{params.unit_type | deal('unit')}}）</span>

      <div class="condition">
        <div class="change-unit">
          <Dropdown @on-click="handleChangeUnit">
            <a href="javascript:void(0)">{{params.unit_type | deal('unit')}}</a>
            <DropdownMenu slot="list">
              <DropdownItem v-for="item in unit_list" :name="item.id" :key="item.id" :disabled="item.id == params.unit_type">{{ item.name }}</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
        <div class="time_sel">
          <Dropdown @on-click="haddleChangeYQ1">
            <a href="javascript:void(0)">{{params.count_type == '0' ? '季度' : '年度'}}</a>
            <DropdownMenu slot="list">
              <DropdownItem name="1" :disabled="params.count_type == '1'">年度</DropdownItem>
              <DropdownItem name="0" :disabled="params.count_type == '0'">季度</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
        <div class="location">
          <AddressTab @selectAddress="addressChecked"></AddressTab>
        </div>
        <!-- <div class="upload">
          <a @click="downloadEcharts"><i class="iconfont">&#xe644;</i>下载</a>
        </div> -->
      </div>
    </div>
    <div class="condition condition2" v-show="!spinShow">
      <div class="time_sel2">
        <div class="ivu-checkbox-group">
          <label class="ivu-checkbox-wrapper ivu-checkbox-default" @click="haddleChangeKey('amount')">
            <span :class="{'ivu-checkbox': true, 'ivu-checkbox-checked': showSeries.amount}">
              <span class="ivu-checkbox-inner"></span>
            </span>
            <span>平均融资额</span>
          </label>
          <label class="ivu-checkbox-wrapper ivu-checkbox-default" @click="haddleChangeKey('growth_rate')">
            <span :class="{'ivu-checkbox': true, 'ivu-checkbox-checked': showSeries.growth_rate}">
              <span class="ivu-checkbox-inner"></span>
            </span>
            <span>增长率</span>
          </label>
        </div>
      </div>
    </div>
    <div class="chart" id="chart" :key="page_title + name"></div>
    <div class="time_slier">
      <Slider v-model="years" range :min="2011" :step="0.01" :tip-format="sliderTipFormat" :max="moment_year" @on-change="hadleTimeSlider" class="year_slider"></Slider>
      <div style="slier_axis" class="slier_axis">
        <span v-for="item,index in slier_axis" :key="item"  :style="'left:' + (100 / (slier_axis.length - 1)) * index + '%'">{{item}}</span>
      </div>
    </div>
    <p class="data_src"><span>数据来源：动脉橙数据库</span><span>数据截止时间：{{today}}</span></p>
  </div>
  <div class="top-tip">全部<span>（{{total}}）</span>
    <Dropdown @on-click="haddleChangeSort">
      <a href="javascript:void(0)">{{sort_id | dealName(sort_list)}}<i class="iconfont">&#xe6ea;</i></a>
      <DropdownMenu slot="list">
        <DropdownItem v-for="item in sort_list" :key="item.id" :name="item.id" :disabled="sort_id === item.id">{{item.name}}</DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </div>
  <div class="list_div">
    <Table :columns="columns" :data="list"></Table>
    <div class="page clear" v-if="total > 10">
      <Page :total="total" :page-size="10" :current="list_params.page" class="page_list" show-total show-elevator @on-change="handleChangePage" ref="pages" />
    </div>
  </div>
  <Contanct></Contanct>
  <DownloadCharts v-if="visible" :visible="visible" :imgbase="imgbase" :tabTitle="name" :params="params" @closeecharts="closeEcharts"></DownloadCharts>
  <Spin fix v-if="spinShow">
    <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
    <div>Loading</div>
  </Spin>
</div>
</template>

<script>
import filter from 'js/filter'
import Contanct from '../Contanct'
import AddressTab from '../AddressTab'
import DownloadCharts from '../DownloadCharts'
import {
  financing_common
} from 'js/financing_mixins'
import echarts from 'echarts'
import {
  option1,
  year_option
} from 'js/financing_chart'
import {
  trendMapAmount, trendOfEventList
} from '../../../../service'
import moment from 'moment'

export default {
  mixins: [financing_common],
  components: {
    Contanct,
    AddressTab,
    DownloadCharts
  },
  data() {
    return {
      page_title: '投融资总趋势',
      name: '平均融资额',
      quarter_option: option1,
      year_option: year_option,
      list: [],
      list_params: {
        user_key: this.$store.state.user_key,
        page: 1,
        sort_type: 0,
        demostic: '',
        address_id: '',
        other_address: [],
        s_time: 2011,
        e_time: parseInt(moment().format('YYYY')),
        round_ids: []
      },
      params: {
        user_key: this.$store.state.user_key,
        demostic: '',
        address_id: '',
        other_address: [],
        s_time: 2011,
        e_time: parseInt(moment().format('YYYY')),
        map_type: 1,
        unit_type: 3,
        count_type: 1
      },
      showSeries: {
        amount: true,
        growth_rate: true
      }
    }
  },
  methods: {
    async getMap() {
      this.mychart.clear()
      this.curInt = ''
      this.showSeries = {
        amount: true,
        growth_rate: true
      }
      let res = await trendMapAmount(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        if (this.is_destroyed) {
          return false
        }
        // 图表数据
        let chart_data = res.res,
          n_unit = this.params.unit_type,

          q_amount = [],
          q_rate = [],
          y_amount_q1 = [],
          y_amount_q2 = [],
          y_amount_q3 = [],
          y_amount_q4 = [],
          y_rate = [],
          y_ave = []

        // this.mychart = chart
        this.time_axis.map((a) => {
          let index1 = chart_data.findIndex((b) => {
            return a == b.e_time_year && b.Q_num == 1
          })
          if (index1 > -1) {
            q_amount.push(filter.amountFilter(chart_data[index1].total))
            q_rate.push(filter.floatNumber(chart_data[index1].growth_rate))
            y_amount_q1.push(filter.amountFilter(chart_data[index1].total))
          } else {
            q_amount.push(0)
            q_rate.push(0)
            y_amount_q1.push(0)
          }

          let index2 = chart_data.findIndex((b) => {
            return a == b.e_time_year && b.Q_num == 2
          })
          if (index2 > -1) {
            q_amount.push(filter.amountFilter(chart_data[index2].total))
            q_rate.push(filter.floatNumber(chart_data[index2].growth_rate))
            y_amount_q2.push(filter.amountFilter(chart_data[index2].total))
          } else {
            q_amount.push(0)
            q_rate.push(0)
            y_amount_q2.push(0)
          }

          let index3 = chart_data.findIndex((b) => {
            return a == b.e_time_year && b.Q_num == 3
          })
          if (index3 > -1) {
            q_amount.push(filter.amountFilter(chart_data[index3].total))
            q_rate.push(filter.floatNumber(chart_data[index3].growth_rate))
            y_amount_q3.push(filter.amountFilter(chart_data[index3].total))
          } else {
            q_amount.push(0)
            q_rate.push(0)
            y_amount_q3.push(0)
          }

          let index4 = chart_data.findIndex((b) => {
            return a == b.e_time_year && b.Q_num == 4
          })
          if (index4 > -1) {
            q_amount.push(filter.amountFilter(chart_data[index4].total))
            q_rate.push(filter.floatNumber(chart_data[index4].growth_rate))
            y_amount_q4.push(filter.amountFilter(chart_data[index4].total))
          } else {
            q_amount.push(0)
            q_rate.push(0)
            y_amount_q4.push(0)
          }
          if (res.growth_rate.length > 0) {
            let r_index = res.growth_rate.findIndex((b) => b.e_time_year == a)
            if (r_index > -1) {
              y_rate.push(filter.floatNumber(res.growth_rate[r_index].growth_rate))
              y_ave.push(filter.amountFilter(res.growth_rate[r_index].total))
            } else {
              y_rate.push(0)
              y_ave.push(0)
            }
          }
        })

        if (this.params.count_type == '1') { //按年筛选
          // 设置name
          let arr = ['Q1平均融资额' + '|' + n_unit, 'Q2平均融资额' + '|' + n_unit, 'Q3平均融资额' + '|' + n_unit, 'Q4平均融资额' + '|' + n_unit, '增长率']
          this.year_option.legend.data = arr
          this.year_option.series[0].name = 'Q1平均融资额' + '|' + n_unit
          this.year_option.series[1].name = 'Q2平均融资额' + '|' + n_unit
          this.year_option.series[2].name = 'Q3平均融资额' + '|' + n_unit
          this.year_option.series[3].name = 'Q4平均融资额' + '|' + n_unit
          this.year_option.series[4].name = '增长率'
          this.year_option.series[5].name = '平均融资额'
          // X轴
          this.year_option.xAxis[0].data = this.time_axis
          // Y轴 金额
          this.year_option.series[0].data = y_amount_q1
          this.year_option.series[1].data = y_amount_q2
          this.year_option.series[2].data = y_amount_q3
          this.year_option.series[3].data = y_amount_q4
          // Y轴 增长率曲线
          this.year_option.series[4].data = y_rate
          // 年度总融资额
          this.year_option.series[5].data = y_ave
          // 皮肤切换
          this.getyearColor()
          this.echartChangeTheme1()
          this.mychart.setOption(this.year_option, true)
          this.mychart.off('click')
          this.mychart.on('click', (params) => {
            this.loginVipFlow(() => {
              this.haddleClickChart1(params)
              this.mychart.setOption(this.year_option)
            })
          });

        } else {
          // 设置name
          this.quarter_option.legend.data = ['平均融资额' + '|' + n_unit, '增长率']
          this.quarter_option.series[0].name = '平均融资额' + '|' + n_unit
          this.quarter_option.series[1].name = '增长率'
          // X轴
          this.quarter_option.xAxis[0].data = this.quarter_arr
          this.quarter_option.xAxis[1].data = this.time_axis
          // Y轴 金额
          this.quarter_option.series[0].data = q_amount
          // Y轴 增长率曲线
          this.quarter_option.series[1].data = q_rate
          //设置图表样式
          this.quarter_option.xAxis[1].show = true
          this.quarter_option.grid.bottom = '20px'
          this.quarter_option.series[0].barWidth = 18
          this.quarter_option.series[0].label.normal.show = false
          this.quarter_option.series[1].label.normal.show = false
          // 皮肤切换
          this.echartChangeTheme1()
          this.mychart.setOption(this.quarter_option, true)
          this.mychart.off('click')
        }

        this.spinShow = false
      } else {
        this.$Message.error(res.msg)
      }
    },
    async getList() {
      let res = await trendOfEventList(this.list_params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        // 列表数据
        this.$set(this.$data, 'list', res.res)
        if (this.list_params.page == 1) {
          this.$set(this.$data, 'total', res.count)
        }
      } else {
        this.$Message.error(res.msg)
      }
    },
    haddleChangeKey(name) {
      this.loginVipFlow(() => {
        if (name == 'amount') {
          this.showSeries.amount = !this.showSeries.amount
          if (this.params.count_type == '1') {
            let arr = ['Q1平均融资额' + '|' + this.params.unit_type, 'Q2平均融资额' + '|' + this.params.unit_type, 'Q3平均融资额' + '|' + this.params.unit_type, 'Q4平均融资额' + '|' + this.params.unit_type]
            arr.map((a) => {
              this.mychart.dispatchAction({
                type: this.showSeries.amount ? 'legendSelect' : 'legendUnSelect',
                name: a
              })
            })
          } else {
            this.mychart.dispatchAction({
              type: this.showSeries.amount ? 'legendSelect' : 'legendUnSelect',
              name: '平均融资额' + '|' + this.params.unit_type
            })
          }
        } else if (name == 'growth_rate') {
          this.showSeries.growth_rate = !this.showSeries.growth_rate
          this.mychart.dispatchAction({
            type: this.showSeries.growth_rate ? 'legendSelect' : 'legendUnSelect',
            name: '增长率'
          })
        }
      })
    }
  },
  mounted() {
    this.mychart = echarts.init(document.getElementById('chart'))
    this.getMap()
    this.getList()
  },
  destroyed() {
    this.year_option = ''
    this.quarter_option = ''
    this.mychart = ''
  },
  watch: {
    theme_switch(val) {
      if (!this.spinShow) {
        this.showSeries = {
          amount: true,
          growth_rate: true
        }
        this.echartChangeTheme1()
        if (this.params.count_type == '1') {
          this.mychart.setOption(this.year_option, true)
        } else {
          this.mychart.setOption(this.quarter_option, true)
        }
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/financing.stylus'
</style>
